type StringFilter = {
    include?: string[];
    exclude?: string[];
    custom?: (items: string[]) => boolean;
};

const stringFilterableProperties = ["areas", "categories", "tags"] as const;
type StringFilterableProperty = typeof stringFilterableProperties[number];

const emptyStringFilter: StringFilter = {
    include: [],
    exclude: [],
};

export { emptyStringFilter, stringFilterableProperties };
export type { StringFilter, StringFilterableProperty };
